import { KeywordDefinition } from 'ajv'

export const nonEmpty: KeywordDefinition = {
  keyword: 'nonEmpty',
  type: 'string',
  errors: false,
  schema: false,
  validate: (data: any) => !!data.trim().length
}
